import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordModule } from 'primeng/password';
import { SharedModule } from '../../../shared/shared.module';
import { InputPasswordComponent } from './input-password.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    PasswordModule,
  ],
  declarations: [InputPasswordComponent],
  exports: [InputPasswordComponent],
})
export class InputPasswordModule {}
